module.exports = "<cfe-header></cfe-header>\n{{runChangeDetection}}\n<router-outlet></router-outlet>\n"